import './loader.scss';

const Loader = () => (
  <div className="loader">
    <div className="loader__ring">
      Loading
      <span className="loader__span" />
    </div>
  </div>
);

export default Loader;
